import { RouteService } from "../services/route";
import { routes } from "./routes";

export const init = () => {
  Object.keys(routes).forEach((route: string) => {
    RouteService.set(route, routes[route]);
  });
};
